export const usersCountryList = ["--Select--", "Germany", "Canada", "Usa", "Aus"];

export const addProjectsUploadHead = [
    {name: 'Project Name'},
    {name: 'Date'},
    {name: 'Status'},
    {name: 'Price'},
    {name: ''},
]